
import { useEffect, useRef, useState } from 'react';

export default function FinalCTA() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Guard against environments where IntersectionObserver is not available
    if (typeof IntersectionObserver === 'undefined') return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) setVisible(true);
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      id="contact"
      className="relative py-0 overflow-hidden"
    >
      {/* Full‑bleed cinematic background */}
      <div className="relative w-full min-h-[600px] flex items-center justify-center">
        <img
          src="https://public.readdy.ai/ai/img_res/c077f2e4b6d41bb792cced36814f8fe1.jpg"
          alt="Your Future System"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-[#0B0D10]/75"></div>

        <div
          className={`
            relative z-10 max-w-3xl mx-auto px-6 text-center py-32
            transition-all duration-1000
            ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}
          `}
        >
          <p className="text-xs font-semibold tracking-[0.35em] text-[#8C9198] mb-5 uppercase">
            Get Started
          </p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-white leading-[1.08] tracking-tight">
            Ready to Build a System That Matches Your Brand?
          </h2>

          <p className="text-lg text-[#8C9198] mb-12 font-light max-w-xl mx-auto leading-relaxed">
            Stop relying on manual processes. Start operating like a premium
            organization.
          </p>

          <a
            href="#contact"
            className="inline-block px-10 py-4 bg-white text-[#0B0D10] font-semibold text-base rounded-full transition-all duration-300 hover:scale-105 hover:shadow-[0_0_50px_rgba(255,255,255,0.2)] cursor-pointer whitespace-nowrap"
          >
            Schedule Your Private Strategy Call
          </a>
        </div>
      </div>
    </section>
  );
}
